<script>
import { globalVariablesMixin } from '../../../Mixins/global'

export default {
  mixins: [globalVariablesMixin],

  props: {
    title: String,
    titleT: String,
    classHeader: String,
  },

  computed: {
    titleComputed: function () {
      if (this.titleT) {
        return this.$t(this.titleT)
      }
      return this.title
    },

    hasHeader: function () {
      if (this.titleComputed || this.$slots.header) {
        return true
      }
      return false
    },

    computeHeader: function () {
      let header = 'header-info mt-0 mb-0'
      if (this.classHeader) {
        header += ' ' + this.classHeader
      }
      return header
    },
  },
}
</script>
<template>
  <main>
    <header v-if="hasHeader" class="header row">
      <div :class="computeHeader">
        <div class="left">
          <span v-if="titleComputed" class="header-title h1 ml-2">
            {{ titleComputed }}
            <slot name="header-title"></slot>
          </span>
        </div>
        <slot name="header"></slot>
      </div>
    </header>
    <slot></slot>
  </main>
</template>
